import { useToast } from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-default.css';

const $toast = useToast({
  position: 'top-right',
  duration: 5000,
  dismissible: true,
  pauseOnHover: true,
});

export default {
  namespaced: true,
  actions: {
    success(_: any, message: string) {
      $toast.success(message);
    },
    error(_: any, message: string) {
      $toast.error(message);
    },
    warning(_: any, message: string) {
      $toast.warning(message);
    },
    info(_: any, message: string) {
      $toast.info(message);
    },
    default(_: any, message: string) {
      $toast.default(message);
    },
  },
};
